import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import {
    DEFAULT_COACHING_SECTION_DATA,
    DEFAULT_COACHING_SECTION_DURATION_SECONDS,
    DEFAULT_SECTION_DURATION,
    DEFAULT_WORKOUT_SECTION_DATA,
} from '../configs/sections-editor/default-section.config';
import { CoachingSectionType, SectionType, WorkoutSectionOf } from '../types/section.type';
import { secondsToDuration } from './duration.utils';

let index: number = 0;

export function createDefaultWorkoutSection<M extends WorkoutMode>(
    mode: M,
    overrides?: Partial<Pick<WorkoutSectionOf<M>, 'id' | 'duration'>>,
): WorkoutSectionOf<M> {
    return {
        id: overrides?.id ?? generateSectionId(),
        data: { ...DEFAULT_WORKOUT_SECTION_DATA[mode] },
        duration: { ...(overrides?.duration ?? DEFAULT_SECTION_DURATION) },
    };
}

export function createDefaultCoachingSection(): SectionType<CoachingSectionType> {
    return {
        id: generateSectionId(),
        data: { ...DEFAULT_COACHING_SECTION_DATA },
        duration: secondsToDuration(DEFAULT_COACHING_SECTION_DURATION_SECONDS),
    };
}

export function generateSectionId(): number {
    index += 1;
    return index;
}
